import React from 'react'
import { numberFormatter } from '../../helper';

const TableSakip = ({ dataTable = [] }) => {
    const htmlRemover = (string) => {
        const regex = /(<([^>]+)>)/gi;
        const result = string.replace(regex, "");
        return result
    }
    return (
        <div className="w-full sm:overflow-visible overflow-x-auto flex flex-col justify-center">
            <table className="w-full md:w-2/3 table-auto text-xs mb-4 mx-auto">
                <thead className="bg-primeColor1 text-white sticky top-0">
                    <tr>
                        <th className="border border-slate-500  w-[1%]" rowSpan={2}>
                            No
                        </th>
                        <th className="border border-slate-500 md:w-2/5" rowSpan={2}>
                            Sasaran
                        </th>
                        <th className="border border-slate-500 w-[30%]" rowSpan={2}>
                            Indikator
                        </th>
                        <th className="border border-slate-500 md:w-[5%]" rowSpan={2}>
                            Satuan
                        </th>
                        <th className="border border-slate-500" colSpan={3}>
                            <span>Capaian Perjanjian Kinerja Gubernur</span>
                        </th>
                        {
                            // triwulan.map((item, index) => {
                            //     return (
                            //         <th className="border border-slate-500" colSpan={3} key={index}>
                            //             <span>{`Triwulan ${index+1}`}</span>
                            //         </th>
                            //     )
                            // })
                        }
                    </tr>
                    <tr>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Target</span>
                            <span className='inline md:hidden'>T</span>
                        </th>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Realisasi</span>
                            <span className='inline md:hidden'>R</span>
                        </th>
                        <th className="border border-slate-500">
                            <span className='hidden md:inline'>Capaian</span>
                            <span className='inline md:hidden'>C</span>
                        </th>
                        {
                            // triwulan.map((item, index) => {
                            //     return (
                            //         <>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Target</span>
                            //                 <span className='inline md:hidden'>T</span>
                            //             </th>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Realisasi</span>
                            //                 <span className='inline md:hidden'>R</span>
                            //             </th>
                            //             <th className="border border-slate-500" key={index}>
                            //                 <span className='hidden md:inline'>Capaian</span>
                            //                 <span className='inline md:hidden'>C</span>
                            //             </th>
                            //         </>
                            //     )
                            // })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        dataTable ? dataTable.map((item, index) => {
                            return (
                                <>
                                    {item.indikator.map((indikator, indIndex) => (
                                        <tr className='odd:bg-primeColor2' key={indIndex}>
                                            {indIndex === 0 && (
                                                <>
                                                    <td className="border border-slate-500 bg-secondaryColor2 p-2 text-right align-top" rowSpan={item.indikator.length}>{index + 1}</td>
                                                    <td className="border border-slate-500 bg-secondaryColor2 p-2 align-top" rowSpan={item.indikator.length}>{item.nm_sasaran}</td>
                                                </>
                                            )}
                                            <td className="border border-slate-500 p-2">{indikator.nm_sasaran_indikator}</td>
                                            <td className="border border-slate-500 p-2 text-center">{htmlRemover(indikator.satuan)}</td>
                                            {/* <td className="border border-slate-500 p-2 text-right">{indikator.target_tw1}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.realisasi_tw1}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.capaian_tw1}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.target_tw2}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.realisasi_tw2}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.capaian_tw2}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.target_tw3}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.realisasi_tw3}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.capaian_tw3}</td> */}
                                            <td className="border border-slate-500 p-2 text-right">{numberFormatter(indikator.target_tw4)}</td>
                                            <td className="border border-slate-500 p-2 text-right">{indikator.realisasi_tw4 !== "" ? numberFormatter(indikator.realisasi_tw4) : '0'}</td>
                                            <td className="border border-slate-500 p-2 text-right">{numberFormatter(indikator.capaian_tw4)}</td>
                                        </tr>
                                    ))}
                                </>
                            );
                        }) :
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan="100%">Loading...</td>
                        </tr>
                    }
            
                </tbody>
            </table>
            {/* <span className="text-red-400 text-xs font-bold">
                Notes : <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; *) Data triwulan IV
            </span> */}
        </div>
    )
}

export default TableSakip